import React, { useContext } from "react";
import { AlertHolder } from "best-common-react";
import { AlertsContext } from "./AlertsContext";
import styled from "styled-components";

const AlertWrapper = styled.div`
  > div {
    > div {
      display: table;
      left: 0px;
      right: 0px;
      margin: 0 auto;
      width: fit-content;
    }
  }
`;

const LineupCardAlerts = () => {
  const alertContext = useContext(AlertsContext);

  return (
    <AlertWrapper id="lineupcard-alerts">
      <AlertHolder
        fullWidth={false}
        alerts={alertContext.alerts}
        onRemove={id => {
          if (id) {
            alertContext.removeAlert(id);
          }
        }}
      />
    </AlertWrapper>
  );
};

export default LineupCardAlerts;
